import React, { useMemo } from "react";
import { Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import "./documentinfomodal.scss";
type DocumentInfoModalProps = {
  handleClose: () => void;
  infoData: any;
};
function DocumentInfoModal({ handleClose, infoData }: DocumentInfoModalProps) {
  const sections = useMemo(() => {
    const section_list = new Set<string>();
    infoData.customers?.forEach(({ section }: any) => {
      section_list.add(section);
    });

    return Array.from(section_list).join(", ");
  }, [infoData]);

  return (
    <Dialog open={true} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle className="flex items-center justify-between">
        Circular Information
        <CloseIcon className="assets-info-popup-close-icon pointer" onClick={handleClose} />
      </DialogTitle>
      <DialogContent>
        <div className="gap-2 document-info-modal-container">
          <Typography className="document-info-modal-content-item-title">Uploading Date Time: </Typography>
          <Typography className="document-info-modal-content-item">
            {infoData?.upload_date ? dayjs(infoData?.upload_date).format("DD-MM-YYYY HH:mm:ss") : "-"}
          </Typography>
          <Typography className="document-info-modal-content-item-title">Document name: </Typography>
          <Typography className="document-info-modal-content-item">{infoData.document_name}</Typography>
          <Typography className="document-info-modal-content-item-title">Document Type: </Typography>
          <Typography className="document-info-modal-content-item">{infoData.document_type}</Typography>

          <Typography className="document-info-modal-content-item-title">Issued By: </Typography>
          <Typography className="document-info-modal-content-item">{infoData.issued_by}</Typography>

          <Typography className="document-info-modal-content-item-title">Section: </Typography>
          <Typography className="document-info-modal-content-item">{sections}</Typography>

          <Typography className="document-info-modal-content-item-title">Issued Date: </Typography>
          <Typography className="document-info-modal-content-item">
            {infoData?.published_dt ? dayjs(infoData.published_dt).format("DD-MM-YYYY") : "-"}
          </Typography>

          <Typography className="document-info-modal-content-item-title">User Role: </Typography>
          <Typography className="document-info-modal-content-item">{infoData?.user_role || "-"}</Typography>

          <Typography className="document-info-modal-content-item-title">Brief Description: </Typography>
          <Typography className="document-info-modal-content-item">{infoData?.remark || "-"}</Typography>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default DocumentInfoModal;
